import dayjs from "dayjs";
import { ReactComponent as ChevronLeftIcon } from "../../../assets/icons/chevron-left.svg";
import { ReactComponent as UserIcon } from "../../../assets/icons/user.svg";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock.svg";
import { secondsToMinute } from "../../praxis-call/utils";
import { ObjectionLevelConfig, ObjectionLevelTitles } from "../../../constant";
import { PraxisScoreCell } from "../../praxis-play-dashboard/components/ReportsTable";

type CallCardProps = {
    session: any;
    practitionerTypeLabel: string;
    personalityLabels: string;
    onClick?: () => void;
    clickable?: boolean;
    testId?: string;
};

export function CallCard({
    session,
    practitionerTypeLabel,
    personalityLabels,
    onClick,
    clickable = true,
    testId,
}: CallCardProps) {
    const date = dayjs(session.startTime).format("MMM DD, YYYY");
    const duration = secondsToMinute(session.durationSeconds || 0);
    const objection =
        ObjectionLevelTitles[
        session.objectionLevel as keyof typeof ObjectionLevelTitles
        ] || session.objectionLevel;
    const hasEndReason = !!session?.endReason || !!session?.end_reason;
    const isPracticeMode = session?.isUnscored;
    const score = session?.score ?? 0;
    const objectionLevelConfig = ObjectionLevelConfig[session.objectionLevel as keyof typeof ObjectionLevelConfig] ?? {
        backgroundColor: "#F3F4F6",
        color: "#374151",
    };

    return (
        <div
            data-testid={testId}
            data-clickable={clickable ? "true" : "false"}
            className={`w-full p-[14px] bg-white rounded-[12px] border border-gray-100 flex flex-col gap-2 ${clickable ? "cursor-pointer hover:shadow-md transition-shadow" : "opacity-75 cursor-not-allowed"}`}
            onClick={clickable ? onClick : undefined}
        >
            <div className="flex items-center justify-between">
                <div className="text-[clamp(12px,1.5vw,13px)] font-semibold text-gray-601">{date}</div>
                <div>
                    {
                        isPracticeMode ? (
                            <div className="w-fit px-2.5 h-[22px] flex items-center justify-center text-white rounded-full text-xs bg-gray-402">
                                Practice Mode
                            </div>
                        )
                            : hasEndReason ? (
                                <div className="w-fit px-2.5 h-[22px] flex items-center justify-center rounded-full text-[13px] text-gray-500 bg-transparent">
                                    Call Ended
                                </div>
                            ) : (
                                <PraxisScoreCell score={score} showStar={false} className="!w-[42px] !rounded-full !h-[22px] !text-sm !font-semibold" />
                            )
                    }
                </div>
            </div>
            <div>
                <div className="text-base font-semibold text-text3">{practitionerTypeLabel}</div>
            </div>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <div className="text-[clamp(12px,1.5vw,13px)] font-semibold rounded-full px-2.5 py-[5px] rounded-md" style={{
                        backgroundColor: objectionLevelConfig.backgroundColor,
                        color: objectionLevelConfig.color,
                    }}>
                            {objection}
                    </div>
                    <div className="flex items-center h-[26px] gap-2 px-2.5 py-[5px] rounded-md bg-gray-100 text-[clamp(12px,1.5vw,13px)] font-semibold">
                        <UserIcon className="w-4 h-4" />
                        {personalityLabels}</div>
                    <div className="flex items-center h-[26px] gap-2 px-2.5 py-[5px] rounded-md bg-gray-100 text-[clamp(12px,1.5vw,13px)] font-semibold">
                        <ClockIcon className="w-4 h-4 [&_path]:stroke-[#27272A]" />
                        {duration}
                    </div>
                </div>
                <div>
                    {(!session?.endReason && !session?.end_reason) && <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-201">
                        <ChevronLeftIcon className="w-4 h-4 rotate-180" />
                    </div>}
                </div>
            </div>
        </div>
    );
}
